module.exports = __webpack_public_path__ + "img/_led-module-instructions.24b50998.jpg";